export function capitalizeFirstLetter(string?: string): string {
  if (!string || string.length < 1) {
    return '';
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default capitalizeFirstLetter;
